import Vue from 'vue'
import * as modules from './modules.js'

Object.keys(modules).forEach(key => {
	Vue.filter(key, modules[key])
})

Vue.prototype.$filters = modules
